export const directSrcFrom = (raw) => {
  const code = (raw || "").trim();
  const iframeMatch = code.match(/<iframe[^>]*\s+src=["']([^"']+)["'][^>]*>/i);
  const urlMatch = code.match(/^(https?:\/\/[^\s"'<>]+)$/i);
  return iframeMatch ? iframeMatch[1] : (urlMatch ? urlMatch[1] : null);
};

const CAPTURE_SCRIPT = `<script>(function(){
  var THANKS = '<div style="font-family:system-ui,sans-serif;padding:40px 20px;text-align:center;color:#110E0B"><h2 style="margin:0 0 8px">Thank you</h2><p style="margin:0;color:#4A3B32">Your answers have been recorded.</p></div>';
  function label(el, i){ return el.getAttribute('name') || el.getAttribute('data-label') || el.getAttribute('aria-label') || el.getAttribute('placeholder') || el.id || ('field_' + (i + 1)); }
  function collect(root){
    var out = [], seen = {}, els = root.querySelectorAll('input,select,textarea');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], type = (el.type || '').toLowerCase();
      if (type === 'submit' || type === 'button' || type === 'reset' || type === 'hidden' || type === 'file') continue;
      var key = label(el, i);
      if (type === 'checkbox') { if (!el.checked) continue; if (seen[key]) { seen[key].value += ', ' + (el.value || 'yes'); continue; } seen[key] = { question_id: key, value: el.value || 'yes' }; out.push(seen[key]); continue; }
      if (type === 'radio') { if (!el.checked) continue; seen[key] = { question_id: key, value: el.value }; out.push(seen[key]); continue; }
      if (seen[key]) continue;
      seen[key] = { question_id: key, value: el.value || '' }; out.push(seen[key]);
    }
    return out;
  }
  function send(root){
    var answers = collect(root).filter(function(a){ return String(a.value).trim() !== ''; });
    if (!answers.length) { alert('Please fill in the form first.'); return; }
    parent.postMessage({ type: 'vomarc-survey-submit', answers: answers }, '*');
    root.innerHTML = THANKS;
  }
  document.addEventListener('submit', function(e){ e.preventDefault(); e.stopPropagation(); send(e.target); }, true);
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('button,input[type=submit],input[type=button],a') : null;
    if (!b || b.closest('form')) return;
    var t = ((b.textContent || b.value || '') + '').toLowerCase();
    if (/submit|send|done|finish|complete/.test(t)) { e.preventDefault(); send(document.body); }
  }, true);
})();</script>`;

export const withSurveyCapture = (html) => {
  const code = html || "";
  if (/<\/body>/i.test(code)) return code.replace(/<\/body>/i, `${CAPTURE_SCRIPT}</body>`);
  return `${code}${CAPTURE_SCRIPT}`;
};
